import {ReactElement} from "react";
import {Navigate} from "react-router-dom";
import {useAuth} from "../context/AuthContext";

type RoleRouteProps = {
    element: ReactElement;
    roles: string[];
};

const RoleRoute = ({element, roles}: RoleRouteProps) => {
    const {user, isLoading} = useAuth();

    if (isLoading) return null;

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const userRoleCodes = (user.roles || []).map((r: any) => r.name);
    const hasAccess = roles.some((allowed) => userRoleCodes.includes(allowed));

    if (!hasAccess) {
        return <Navigate to="/forbidden" replace />;
    }

    return element;
};

export default RoleRoute;
